<template>
  <div class="d-flex justify-content-center container-geral">
    <div class="container-components">
      <Sale @getAllSales="getAllSales = $event" />
    </div>
  </div>
</template>

<script>
import Sale from "../Sale/Sale.vue";
export default {
  components: {
    Sale,
  },
  data() {
    return {
      idSale: "",
      getAllSales: null,
    };
  },
};
</script>
<style scoped>
.container-geral {
  width: 100% !important;
}

.container-components {
  width: 100%;
  transition: all 0.7s ease-in-out;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .container-components {
    width: 100%;
  }
  .totals {
    font-size: 12px !important;
  }
  .dataSaleItems {
    font-size: 11px;
    margin-top: 9px;
  }
}

@media screen and (max-width: 700px) {
  .container-components {
    width: 100%;
  }
}
</style>